<template>
  <div class="margin-subpages">
    <div class="fs-18 fw-700">
      Features in Development <span style="font-style: italic">(Alpha)</span>
    </div>
    <div class="mt-12 mb-12"></div>
    <div class="ml-24">
      <!-- <div class="fs-16">
        Organizations Relationships
        <span class="fs-12 opa-06">Insights > Relationships</span>
      </div> -->
      <div class="fs-16">
        Awards
        <span class="fs-12 opa-06">Awards</span>
      </div>
      <div class="fs-16">
        Document Developer
        <span class="fs-12 opa-06">Document Developer > *All</span>
      </div>
    </div>
    <div class="mt-12 mb-12"></div>
    <div class="fs-18 fw-700">
      Features Testing <span style="font-style: italic">(Beta)</span>
    </div>
    <div class="mt-12 mb-12"></div>
    <div class="ml-24">
      <div class="fs-16">
        -
        <span class="fs-12 opa-06"></span>
      </div>
    </div>
    <div class="mt-32 mb-32"></div>
    <div class="fs-18 fw-700">Update History</div>
    <div class="mt-25 mb-16"></div>
    <!-- <div class="line-style mt-25 mb-16"></div> -->
    <el-collapse v-model="activeName">
      <!-- <el-collapse-item name="Sep 2022">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version X.XX</div>
            <div class="fs-12 ml-16 mt-3 opa-08">December 2022</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">New features</div>
          <ul>
            <li>
              <div>
                <span class="title-list-style">header</span>
                : ######
              </div>
              <div class="fs-12 opa-06">Where</div>
            </li>
          </ul>
          <div class="header-label ml-20">Bug fixes & Improvements</div>
        </div>
      </el-collapse-item> -->
      <el-collapse-item name="May_2023">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version 1.23</div>
            <div class="fs-12 opa-08">May 2023</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">New features</div>
          <ul>
            <li>
              <div>
                <span class="title-list-style"
                  >Organizations Relationships</span
                >
                : Create a table (similar to the manager tab) that lists members
                as selected in the teams drop-down at the top of the view. Add a
                filter dropdown (similar to previous views). Allow the user to
                filter based on existing Signatures (update when we add new
                signatures)
                <span class="fw-700">Now available to production.</span>
              </div>
              <div class="fs-12 opa-06">Insights > Relationships</div>
            </li>
            <li>
              <div>
                <span class="title-list-style">Happily Recognition API</span>
                : Allow the user to input a Team or Cohort ID to send
                recognition via the API (compatible with the Zapier
                Integration). Create an Internal Value label in the Teams and
                Cohorts view so that the admin can select and copy the ID.
              </div>
              <div class="fs-12 opa-06">Insights > Teams, Cohorts</div>
            </li>
          </ul>
          <div class="header-label ml-20">Bug fixes & Improvements</div>
          <ul>
            <li>
              <div>
                <div>
                  <span class="title-list-style"
                    >Integration [Teams and Cohorts]</span
                  >
                </div>
                <div>
                  Allow the user to input a Team or Cohort ID to send
                  recognition via the API (compatible with the Zapier
                  Integration). Create an Internal Value labelso that the admin
                  can select and copy the ID to use in the API.
                </div>
                <div class="fs-12 opa-06">
                  Members > Teams View, Cohorts View
                </div>
              </div>
            </li>
            <li>
              <div>
                <span class="title-list-style">Filter Questions</span>
                : Add Dimension filters to the recognition activity data table.
              </div>
              <div class="fs-12 opa-06">Questions > Standard, Custom</div>
            </li>
          </ul>
        </div>
      </el-collapse-item>
      <el-collapse-item name="Apr_2023">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version 1.23</div>
            <div class="fs-12 opa-08">April 2023</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">New features</div>
          <ul>
            <li>
              <div>
                <span class="title-list-style">Zapier Integrations</span>
                : (Opened some company) Embed Zapier into that view, Allow
                connect business workflows to Happily and automated send
                recognition based on various triggers
              </div>
              <div class="fs-12 opa-06">Insights > Integrations</div>
            </li>
            <li>
              <div>
                <span class="title-list-style">Archived Type</span>
                : Classify Archived Members. Replace the Permissions/Role with a
                Archived Type column that displays the archive type with a
                drop-down to allow the user to change the type. Add a drop-down
                menu for the user to select the reason for the member being
                archived in our system
                <div class="mt-4">
                  <span style="font-style: italic"
                    >Type of Archive: Resigned, Terminated, Other</span
                  >
                </div>
              </div>
              <div class="fs-12 opa-06">
                Members > Profile View, Archived View
              </div>
            </li>
            <li>
              <div>
                <span class="title-list-style"
                  >Impact Rating and Retention Rate by team</span
                >
                : Display the average impact rating for that team by taking the
                average impact rating for each member of that team and sub-team.
                Display the retention rate for that team by looking at the
                number of employees at the beginning of the time period and
                compare it with the number of employees left at the end of the
                time period (do not include new hires who joined during this
                period).
              </div>
              <div class="fs-12 opa-06">Insights > Teams, Cohorts</div>
            </li>
          </ul>
          <div class="header-label ml-20">Bug fixes & Improvements</div>
          <ul>
            <!-- <li>
              <div>
                <span class="title-list-style">New Tone Analysis</span>
                : Tone Analysis section to support new tone methodology. Show
                the relative tone frequency by over the past 7 days by comparing
                the % of times the tone is registered as the dominant tone in
                feedback, recognition, or message replies.
              </div>
              <div class="fs-12 opa-06">Insights > Dashboard</div>
            </li> -->
            <li>
              <div>
                <div><span class="title-list-style">Hotfix:</span></div>
                <div>
                  1. Fixed label showing new line in the tone analysis section.
                </div>
                <div class="fs-12 opa-06">Insights > Dashboard</div>
                <div>
                  2. Fixed Tooltip that show problem areas doesn't correctly.
                  (The Profile views that displays a person's Happiness
                  Timeline, Historical data about People Risk)
                </div>
                <div class="fs-12 opa-06">Profile views</div>
              </div>
            </li>
          </ul>
        </div>
      </el-collapse-item>
      <el-collapse-item name="March_2023">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version 1.21</div>
            <div class="fs-12 opa-08">March 2023</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">New features</div>
          <ul>
            <!-- <li>
              <div>
                <span class="title-list-style"
                  >#### Organizations Relationships</span
                >
                : organizations relationships and networks
              </div>
              <div class="fs-12 opa-06">Insights > Relationships (Alpha)</div>
            </li> -->
            <li>
              <div>
                <span class="title-list-style"
                  >Organizations Relationships</span
                >
                : Organizations relationships and networks, so that easy can
                understand how individuals contribute to the social network
              </div>
              <div class="fs-12 opa-06">Setting</div>
            </li>
            <li>
              <div>
                <span class="title-list-style">Filter recognition</span>
                : Add more features and filters to the recognition activity data
                table. Add sorting for the
                <span style="font-style: italic">Recipient, From, Reward</span>
                and
                <span style="font-style: italic">Sent on</span>
                columns.
              </div>
              <div class="fs-12 opa-06">Power-ups > Activity</div>
            </li>
            <li>
              <div>
                <span class="title-list-style"
                  >Filter Questions & Update data display</span
                >
                : Add more features and filters to the recognition activity data
                table. Update font size, color and showing more data on table.
              </div>
              <div class="fs-12 opa-06">Questions > Standard, Custom</div>
            </li>
          </ul>
          <div class="header-label ml-20">Bug fixes & Improvements</div>
          <ul>
            <li>
              <div>
                <span class="title-list-style">New Tone Analysis</span>
                : Tone Analysis section to support new tone methodology. Show
                the relative tone frequency by over the past 7 days by comparing
                the % of times the tone is registered as the dominant tone in
                feedback, recognition, or message replies.
              </div>
              <div class="fs-12 opa-06">Insights > Dashboard</div>
            </li>
            <li>
              <div>
                <span class="title-list-style">Fixed Header</span>
                : The navigation header will stay at the top of the page while
                scrolling on status table
              </div>
              <div class="fs-12 opa-06">Insights > Teams, Cohorts</div>
            </li>
            <li>
              <div>
                <div><span class="title-list-style">Hotfix:</span></div>
                <div>
                  1. Fixed table sorting show data doesn't correctly when user
                  changed page.
                </div>
                <div class="fs-12 opa-06">
                  Members > Members | Happily Village > University, Town Hall
                </div>
                <div>2. Fixed console error (Date picker)</div>
                <div class="fs-12 opa-06">
                  Setting | Report > Daily, Weekly, Monthly
                </div>
                <div>
                  3. Hidden Integrations Page, This page should be showing only
                  special company.
                </div>
                <div class="fs-12 opa-06">Integrations</div>
              </div>
            </li>
          </ul>
        </div>
      </el-collapse-item>
      <el-collapse-item name="February_2023">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version 1.20</div>
            <div class="fs-12 opa-08">February 2023</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">New features</div>
          <ul>
            <li>
              <div>
                <span class="title-list-style">Recognition #values</span>
                : let's the user to drag and drop the value tags in a particular
                order, The nudges email report will sending following this order
                (1 value tag per week) maximum 8 value. And allowed the user to
                click and edit the text inside a value tag
              </div>
              <div class="fs-12 opa-06">Insights > Relationships (Beta)</div>
            </li>
            <li>
              <div>
                <span class="title-list-style"
                  >Organizations Relationships</span
                >
                : Organizations relationships and networks, so that easy can
                understand how individuals contribute to the social network
              </div>
              <div class="fs-12 opa-06">Insights > Relationships (Alpha)</div>
            </li>
            <li>
              <div>
                <span class="title-list-style">Zapier Integrations</span>
                : Embed Zapier into that view, Allow connect business workflows
                to Happily and automated send recognition based on various
                triggers
              </div>
              <div class="fs-12 opa-06">Insights > Integrations (Alpha)</div>
            </li>
          </ul>
          <div class="header-label ml-20">Bug fixes & Improvements</div>
          <ul>
            <!-- <li>
              <div>
                <span class="title-list-style">Team status tree</span>
                : Allowed the user click on each team for open modal details
                view.
              </div>
              <div class="fs-12 opa-06">Insights > Managers > Detail View</div>
            </li> -->
            <li>
              <div>
                <div><span class="title-list-style">Hotfix:</span></div>
                <div>
                  1. Fixed Recognition trends chart. The total bars display
                  doesn't correctly.
                </div>
                <div class="fs-12 opa-06">Power Ups > Activity</div>
                <div>2. Fixed permission to access Integration page.</div>
                <div class="fs-12 opa-06">Menu</div>
                <div>3. Fixed [bulk function] using comma separated values</div>
                <div class="fs-12 opa-06">
                  Power-ups > Create, Custom | Members > Cohorts
                </div>
              </div>
            </li>
          </ul>
        </div>
      </el-collapse-item>
      <el-collapse-item name="January_2023">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version 1.19</div>
            <div class="fs-12 opa-08">January 2023</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">New features</div>
          <ul>
            <li>
              <div>
                <span class="title-list-style">Engagement Chart</span>
                : Engagement health progress (Line Chart) by dimension by team,
                that displays engagement score. The x-axis match the time scale
                in the chart above and the y-axis have a max of 100 and min can
                be set to auto-adjust based on the dataset.
              </div>
              <div class="fs-12 opa-06">
                Insights > Team > Detail View | Insights > Managers > Detail
                View
              </div>
            </li>
          </ul>
          <div class="header-label ml-20">Bug fixes & Improvements</div>
          <ul>
            <li>
              <div>
                <span class="title-list-style"
                  >the monthly topped-up credits</span
                >
                : Added Top-up Credits to the header section of the monthly
                billing and display the total (sum) of credits topped-up in that
                particular month.
              </div>
              <div class="fs-12 opa-06">Billing (Alpha)</div>
            </li>
            <li>
              <div>
                <span class="title-list-style">Team status tree</span>
                : Allowed the user click on each team for open modal details
                view.
              </div>
              <div class="fs-12 opa-06">Insights > Managers > Detail View</div>
            </li>
            <li>
              <div>
                <div><span class="title-list-style">Hotfix:</span></div>
                <div>1. *Fixed happiness data doesn't load correctly.</div>
                <div class="fs-12 opa-06">Profile views</div>
                <div>
                  2. *Fixed University session detail view show data doesn't
                  correctly (Description, Date label, Price and Conditions).
                </div>
                <div class="fs-12 opa-06">
                  Happily Village > University > Detail view
                </div>
                <div>
                  3. *Fixed Unable to complete text input to Create University
                  Session.
                </div>
                <div class="fs-12 opa-06">
                  Happily Village > University > Create view
                </div>
              </div>
            </li>
          </ul>
        </div>
      </el-collapse-item>
      <el-collapse-item name="December_2022">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version 1.17</div>
            <div class="fs-12 ml-16 mt-3 opa-08">December 2022</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">New features</div>
          <ul>
            <li>
              <div>
                <span class="title-list-style">Leaderboards</span>
                : View your achievements and rankings across engagement
                activities (daily streak, super feedback, and super recognition)
                and power skills development (empathy, leadership,
                initiative-making, optimism, self-awareness, and critical
                thinking). Preview monthly and all-time rankings.
              </div>
              <div class="fs-12 opa-06">Profile views</div>
            </li>
            <li>
              <div>
                <span class="title-list-style">Top skills</span>
                : A list of skills endorsed by others from peer feedback
                interactions, now counted based on unique rather than total
                endorsements.
              </div>
              <div class="fs-12 opa-06">Profile views</div>
            </li>
            <li>
              <div>
                <span class="title-list-style"> Culture Add</span>
                : See who's contributing to your values. A Culture Add section
                has been added to the profile view that displays the #values
                that this person has contributed to based on recognition. A
                percentile rank is displayed showing their relative contribution
                to others over the past six months.
              </div>
              <div class="fs-12 opa-06">Profile views</div>
            </li>
          </ul>
          <div class="header-label ml-20">Bug fixes & Improvements</div>
          <ul>
            <li>
              <div>
                <span class="title-list-style">Profile views</span>
                : Updated the profiles views (Medals, About me, House flag) by
                following mobile version.
              </div>
              <div class="fs-12 opa-06">Profile views</div>
              <!-- <div class="fs-12 opa-06">Members > Members, Members > Managers, Insights > Managers,
              Insights > People</div> -->
            </li>
            <li>
              <div>
                <span class="title-list-style">Question details</span>
                : Showing tooltip when hover responses bar is lower then 5% or
                responses is hidden text.
              </div>
              <div class="fs-12 opa-06">Questions > Responses view</div>
            </li>
            <li>
              <div>
                <span class="title-list-style">Activity reward</span>
                : Resolved issues with label no changed and reward undifined
              </div>
              <div class="fs-12 opa-06">Reward > Activity Modal</div>
            </li>
            <li>
              <div>
                <div><span class="title-list-style">Hotfix:</span></div>
                <div>1. Fixed cache error & Log showing on console</div>
                <div class="fs-12 opa-06">Console</div>
                <div>
                  2. Resolved issues with label no changed and reward undifined
                </div>
                <div class="fs-12 opa-06">Reward > Activity Modal</div>
              </div>
            </li>
          </ul>
        </div>
      </el-collapse-item>
      <el-collapse-item name="September_2022">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version 1.15</div>
            <div class="fs-12 opa-08">September 2022</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">New features</div>
          <ul>
            <li>
              <div>
                <span class="title-list-style">Reward activity</span>
                : Display a simple bar chart that displays the total value of
                rewards redeemed in a certain range. Allow the user to export
                the monthly data to a spreadsheet (xls) file.
              </div>
              <div class="fs-12 opa-06">Insights > Managers</div>
            </li>
          </ul>
          <div class="header-label ml-20">Bug fixes & Improvements</div>
          <ul>
            <li>
              <div>
                <div><span class="title-list-style">Hotfix:</span></div>
                <div>1. Resolved Bill status tags color, status paid</div>
                <div class="fs-12 opa-06">Billing</div>
              </div>
            </li>
          </ul>
        </div>
      </el-collapse-item>
      <el-collapse-item name="August_2022">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version 1.13</div>
            <div class="fs-12 opa-08">August 2022</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">New features</div>
          <ul>
            <li>
              <div>
                <span class="title-list-style">Updated Manager Insights</span>
                : Deeper understanding of manager activity and performance, with
                added clarity on proactivity and psychological safety.
              </div>
              <div class="fs-12 opa-06">Insights > Managers</div>
            </li>
            <li>
              <div>
                <span class="title-list-style">Sparks Nudges</span>
                : Preview nudges that are automatically sent to employees and
                managers to reinforce positive changes and provide interventions
                to unlock engagement.
              </div>
              <div class="fs-12 opa-06">Sparks > Nudges</div>
            </li>
            <li>
              <div>
                <span class="title-list-style">Happily Village Moderation</span
                >: View and add comments in the University and Town Hall using
                the My Happily console.
              </div>
              <div class="fs-12 opa-06">
                Happily Village > University, Town Hall, Running Track
              </div>
            </li>
            <li>
              <div>
                <span class="title-list-style">Billing</span>: Preview bill that
                are...
              </div>
              <div class="fs-12 opa-06">Billing (beta)</div>
            </li>
          </ul>
          <div class="header-label ml-20">Bug fixes & Improvements</div>
          <ul>
            <li>
              <div>
                <span class="title-list-style">User Details</span>
                : Set up a member to a country and timezone, and update new
                Dimension icons
              </div>
              <div class="fs-12 opa-06">Members > Members, Managers</div>
            </li>
            <li>
              <div>
                <span class="title-list-style">New loading</span>
                : Added skeleton loading for main page/tab
              </div>
              <div class="fs-12 opa-06">Insights | Members | Rewards</div>
            </li>
          </ul>
        </div>
      </el-collapse-item>
      <el-collapse-item name="June_2022">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version 1.11</div>
            <div class="fs-12 opa-08">June 2022</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">New features</div>
          <ul>
            <li>
              <div>
                <span class="title-list-style"
                  >Team-based or Cohort-based Questions</span
                >
                : Now available to all! Companies can now create custom
                questions targeted to specific teams and cohorts for more robust
                pulse surveys.
              </div>
              <div class="fs-12 opa-06">Questions > managers</div>
            </li>
            <li>
              <div>
                <span class="title-list-style"
                  >Download Daily & Weekly Reports</span
                >: HR roles can now view and download daily & weekly reports
                from Reports as a PDF file to enhance reporting capabilities.
              </div>
              <div class="fs-12 opa-06">Reports > Daily, Weeky</div>
            </li>
          </ul>
          <div class="header-label ml-20">Bug fixes & Improvements</div>
          <ul>
            <li>
              <div>
                <span class="title-list-style">Dimension images</span>
                : Updated new cover image for dimension.
              </div>
              <div class="fs-12 opa-06">Insights | Questions</div>
            </li>
            <li>
              <div>
                <div><span class="title-list-style">Hotfix:</span></div>
                <div>
                  1. Resolved issues with error log & error when user change tab
                  or page.
                </div>
                <div class="fs-12 opa-06">Router, Console</div>
              </div>
            </li>
          </ul>
        </div>
      </el-collapse-item>
      <el-collapse-item name="May_2022">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version 1.12</div>
            <div class="fs-12 opa-08">May 2022</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">New features</div>
          <ul>
            <li>
              <div>
                <span class="title-list-style"
                  >Create Custom Questions for Teams & Cohorts
                </span>
                : Companies can now create custom questions targeted to specific
                teams and cohorts for more robust pulse surveys.
              </div>
              <div class="fs-12 opa-06">Questions > Add question (beta)</div>
            </li>
            <li>
              <div>
                <span class="title-list-style">Leadership Insights</span>
                : A "leadership" role will have limited visibility to advanced
                insights, scoped to the teams that they look after (according to
                the org structure).
              </div>
            </li>
          </ul>
        </div>
      </el-collapse-item>
      <el-collapse-item name="March_2022">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version 1.11</div>
            <div class="fs-12 opa-08">March 2022</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">New features</div>
          <ul>
            <li>
              <span class="title-list-style">New dashboard</span>
              : An all-new dashboard highlights individual impact (see people
              tab) and manager activity, as well as recent organizational
              metrics from the Report Card. Weekly activity numbers are
              displayed with the adoption rate, monthly active user counts, and
              weekly active user counts. Key metrics are also displayed with
              benchmarks.
              <div class="fs-12 opa-06">Insights > Dashboard</div>
            </li>
            <li>
              <span class="title-list-style">Chart Overview</span>: An in-depth
              overview of individual achievement and impact is displayed in
              detail, along with data visualizations for the development of
              power skills, talent types, network types, and qualities your
              people excel at (from peer feedback interactions). A new
              health bar previews sentiment and an impact rating (ranging from 0
              to 100) represent an individual's contributions to the
              organization.
              <div class="fs-12 opa-06">Insights > People</div>
            </li>
            <li>
              <span class="title-list-style"
                >Presets Library (Automations)</span
              >
              : Set up automated power-ups to recognize key behaviors on a
              monthly, quarterly, or annual basis.
              <div class="fs-12 opa-06">
                Power-ups > Create > Presets Library
              </div>
            </li>
            <li>
              <span class="title-list-style">Recognition Trends</span>
              : Visualize recognition behavior over time and see how your
              organizational values are represented in recognition interactions.
              <div class="fs-12 opa-06">
                Power-ups > Activity > Recognition Trends
              </div>
            </li>
            <li>
              <span class="title-list-style">Org Chart View</span>
              : The org chart view adds an activity status (active, in-active,
              invited, new) and an impact rating to the member cards.
              <div class="fs-12 opa-06">Profile views</div>
            </li>
            <li>
              <span class="title-list-style"
                >Approval Requests for Rewards</span
              >
              : Rewards can be configured to include an approval request flow so
              that managers must approve the request before it can be redeemed
              and delivered.
            </li>
            <li>
              <span class="title-list-style">API config (beta access)</span>
              : On request, API access is available to customers who would like
              to integrate their business workflows with Happily services.
              <div class="fs-12 opa-06">Integrations > API (beta)</div>
            </li>
          </ul>
        </div>
      </el-collapse-item>
      <el-collapse-item name="April_2022">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version 1.9</div>
            <div class="fs-12 ml-16 mt-3 opa-08">April 2022</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">New features</div>
          <ul>
            <li>
              <div>
                <span class="title-list-style">Awards Page</span>
                : Create a new view in My Happily called Awards. This view has 2
                tabs: Status and Timeline.
                <div class="mt-8"></div>
                The status tab shows the user the status of each of the Awards
                they can earn from using Happily.
                <div class="mt-8"></div>
                The Timeline tab shows the history status of each of the Awards.
              </div>
              <div class="fs-12 opa-06">Awards (Alpha)</div>
            </li>
          </ul>
        </div>
      </el-collapse-item>
      <el-collapse-item name="Jan_2022">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version 1.7</div>
            <div class="fs-12 opa-08">Jan 2022</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">New features</div>
          <ul>
            <li>
              <span class="title-list-style"
                >Power-Ups > Recognition #values</span
              >
              : Recognition activity can be filtered by your values.
              <div class="fs-12 opa-06">Power-Ups > Create | Activity</div>
            </li>
            <li>
              <span class="title-list-style">Cohorts</span>: Until now,
              group-level insights have been structured by teams, which are
              created based on your organizational design. Now, you can create
              Cohorts which are your self-defined groups. To get you started, we
              have auto-generated a set of dynamic groups based on job tenure,
              talent type, network type, managers, and engagement group.
              <div class="mt-8"></div>
              Create your own Cohorts and view Cohort level insights from the
              <span class="title-list-style">Insights > Cohort</span> view and
              the
              <span class="title-list-style">Insights > Report Card</span>
              (Cohort toggle) view.
              <div class="fs-12 opa-06">Insights > Cohort | Report Card</div>
            </li>
            <li>
              <span class="title-list-style">Happiness Timeline</span>
              : Better understand your People Risks and Star Performers by
              viewing a timeline of risk and star events for an individual.
              <div class="fs-12 opa-06">Profile views</div>
            </li>
            <li>
              <span class="title-list-style">Settings</span>
              : A new opt-in section for Recognition Values allows you to create
              and manage your set of #values that you’d like to reinforce in
              your organization. Also, language localizations can be added for
              opt-in features.
              <div class="fs-12 opa-06">Settings</div>
            </li>
          </ul>
        </div>
      </el-collapse-item>
      <el-collapse-item name="July_2021">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version 1.6</div>
            <div class="fs-12 opa-08">July 2021</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">New features</div>
          <ul>
            <li>
              <span class="title-list-style">Organiztion Chart View</span>
              : An organization chart view is now available in the Members page.
              The chart can also be downloaded as an image (within a certain
              size limitation). More easily view and manage employee line of
              management and team structure.
              <div class="fs-12 opa-06">Members > Org Chart View</div>
            </li>
            <li>
              <span class="title-list-style">Happily Village Dashboard</span>
              : The Happily Village Dashboard view now includes information on
              activity in the Battle Stadium, counting the number of mission
              entries (submissions) by members.
              <div class="fs-12 opa-06">Happily Village > Overview</div>
            </li>
            <li>
              <span class="title-list-style">Battle Stadium</span>
              : From the Battle Stadium tab, re-sequence to customize the order
              of weekly missions, or create your own! You can assign your
              mission to a preset list of types and reward mission entrants with
              a specified number of XP.
              <div class="fs-12 opa-06">Happily Village > Battle Stadium</div>
            </li>
            <li>
              <span class="title-list-style"
                >Culture, Resilience, and Well-being Index</span
              >
              : The Report Card has been updated to include a new section that
              displays scores from the Culture, Resilience, and Well-Being
              Index. These indexes are scored based on results from a set of
              questions. For example, the Well-Being Index is measured using the
              WHO-5 Index from the World Health Organization.
            </li>
            <li>
              <span class="title-list-style"
                >Bulk-adding members as Power-up Recipients</span
              >
              : Multiple members can be quickly added by copying and pasting a
              list of member names into the recipient input field.
            </li>
          </ul>
          <div class="header-label ml-20">Bug fixes & Improvements</div>
          <ul style="margin-block-start: 8px">
            <li>
              Resolved issues with creating Custom Questions for single language
              accounts
            </li>
          </ul>
        </div>
      </el-collapse-item>
      <el-collapse-item name="May_2021">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version 1.5</div>
            <div class="fs-12 opa-08">May 2021</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">New features</div>
          <ul>
            <li>
              <span class="title-list-style">Calendar View</span>
              : View and manage questions in a calendar view, to see what
              questions will be sent on which day.
              <div class="fs-12 opa-06">Question > Calendar View</div>
            </li>
            <li>
              <span class="title-list-style">Custom Questions</span>
              : New question types, multiple choice and scale, can now be added
              as custom questions. A preview of how results will display in
              Manager Daily Insights is also available.
              <div class="fs-12 opa-06">Questions > Custom Questions View</div>
            </li>
            <li>
              <span class="title-list-style">Question Results</span>
              : View responses to all question types, with the option to export
              the results as an XLS file.
              <div class="fs-12 opa-06">Questions > Question Details View</div>
            </li>
            <li>
              <span class="title-list-style">Custom Rewards</span>
              : Create your own rewards with a preview of how it will be
              displayed in the app.
              <div class="fs-12 opa-06">Rewards > Custom Rewards View</div>
            </li>
            <li>
              <span class="title-list-style">Custom Sparks</span>
              : Create your own Sparks Sets and select the sequence in which
              they should be displayed.
              <div class="fs-12 opa-06">Sparks > Mricro-Learning</div>
            </li>
            <li>
              <span class="title-list-style">Activity Results</span>
              : View all recognition activity shared within Happily, with the
              option to export as an XLS file.
              <div class="fs-12 opa-06">Power-ups > Activity</div>
            </li>
          </ul>
          <div class="header-label ml-20">Bug fixes & Improvements</div>
          <ul style="margin-block-start: 8px">
            <li>
              Resolved success, warning, and error messages to improve
              readability
            </li>
            <li>Added workflows to complete direct manager assignments</li>
            <li>Improved load performance</li>
          </ul>
        </div>
      </el-collapse-item>
      <el-collapse-item name="March_2021">
        <template slot="title">
          <div class="title-custom">
            <div class="fs-18 fw-500">Version 1.4</div>
            <div class="fs-12 opa-08">March 2021</div>
          </div>
        </template>
        <div class="fs-16 container-log">
          <div class="header-label ml-20">Bug fixes & Improvements</div>
          <ul style="margin-block-start: 8px">
            <li>
              <div>
                <div>Improved visual cues for Key Group Activity</div>
                <!-- <div class="fs-12 opa-06">Router, Console</div> -->
              </div>
            </li>
            <li>
              <div>
                <div>
                  Resolved missing data in the Insights > Dashboard > Engagement
                  Dimension Detail view
                </div>
                <!-- <div class="fs-12 opa-06">Router, Console</div> -->
              </div>
            </li>
          </ul>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: "update",
  data() {
    return {
      iconList: "",
      activeName: "May_2023",
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
li {
  margin-top: 8px;
}
ul {
  margin-block-start: 16px;
}
.container-log {
  line-height: 18px;
  // color: #000;
  .header-label {
    font-size: 18px;
    line-height: 18px;
    font-weight: 700;
    color: #5423a2;
  }
}
.title-custom {
  display: flex;
  width: calc(100% - 32px);
  justify-content: space-between;
  color: #000;
}
.title-list-style {
  font-weight: 700;
  text-transform: capitalize;
}
</style>
